export const shiftsTranslations = {
  ar: {
    title: 'إدارة الورديات',
    shifts: 'الورديات',
    openShift: 'فتح وردية',
    closeShift: 'إغلاق وردية',
    activeShift: 'الوردية النشطة',
    noActiveShift: 'لا توجد وردية نشطة',
    shiftDetails: 'تفاصيل الوردية',
    shiftHistory: 'سجل الورديات',
    
    // Form Fields
    branchId: 'الفرع',
    openingBalance: 'الرصيد النقدي الابتدائي',
    closingBalance: 'الرصيد النقدي الفعلي',
    expectedAmount: 'المبلغ المتوقع',
    actualAmount: 'المبلغ الفعلي',
    cashDifference: 'الفرق النقدي',
    differenceReason: 'سبب الفرق',
    notes: 'ملاحظات',
    status: 'الحالة',
    startDate: 'تاريخ البدء',
    endDate: 'تاريخ الانتهاء',
    openedBy: 'فتحت بواسطة',
    closedBy: 'أغلقت بواسطة',
    
    // Status
    statusOpen: 'نشطة',
    statusClosed: 'مغلقة',
    statusCancelled: 'ملغاة',
    
    // Summary
    totalInvoices: 'إجمالي الفواتير',
    totalSales: 'إجمالي المبيعات',
    totalCashSales: 'المبيعات النقدية',
    totalNonCashSales: 'المبيعات غير النقدية',
    openingBalanceLabel: 'الرصيد الابتدائي',
    expectedCashAmount: 'المبلغ النقدي المتوقع',
    excess: 'فائض',
    shortage: 'نقص',
    noDifference: 'لا يوجد فرق',
    
    // Messages
    openSuccess: 'تم فتح الوردية بنجاح',
    closeSuccess: 'تم إغلاق الوردية بنجاح',
    openError: 'حدث خطأ أثناء فتح الوردية',
    closeError: 'حدث خطأ أثناء إغلاق الوردية',
    alreadyActiveShift: 'يوجد وردية نشطة بالفعل',
    noActiveShiftMessage: 'لا توجد وردية نشطة. يرجى فتح وردية قبل إنشاء الفواتير',
    cannotCloseOtherUserShift: 'لا يمكن إغلاق وردية مستخدم آخر',
    confirmClose: 'هل أنت متأكد من إغلاق الوردية؟',
    confirmCloseTitle: 'تأكيد إغلاق الوردية',
    
    // Filters
    filterByBranch: 'تصفية حسب الفرع',
    filterByUser: 'تصفية حسب المستخدم',
    filterByStatus: 'تصفية حسب الحالة',
    filterByDate: 'تصفية حسب التاريخ',
    fromDate: 'من تاريخ',
    toDate: 'إلى تاريخ',
    allBranches: 'جميع الفروع',
    allUsers: 'جميع المستخدمين',
    allStatuses: 'جميع الحالات',
  },
  en: {
    title: 'Shift Management',
    shifts: 'Shifts',
    openShift: 'Open Shift',
    closeShift: 'Close Shift',
    activeShift: 'Active Shift',
    noActiveShift: 'No Active Shift',
    shiftDetails: 'Shift Details',
    shiftHistory: 'Shift History',
    
    // Form Fields
    branchId: 'Branch',
    openingBalance: 'Opening Balance',
    closingBalance: 'Closing Balance',
    expectedAmount: 'Expected Amount',
    actualAmount: 'Actual Amount',
    cashDifference: 'Cash Difference',
    differenceReason: 'Difference Reason',
    notes: 'Notes',
    status: 'Status',
    startDate: 'Start Date',
    endDate: 'End Date',
    openedBy: 'Opened By',
    closedBy: 'Closed By',
    
    // Status
    statusOpen: 'Open',
    statusClosed: 'Closed',
    statusCancelled: 'Cancelled',
    
    // Summary
    totalInvoices: 'Total Invoices',
    totalSales: 'Total Sales',
    totalCashSales: 'Cash Sales',
    totalNonCashSales: 'Non-Cash Sales',
    openingBalanceLabel: 'Opening Balance',
    expectedCashAmount: 'Expected Cash Amount',
    excess: 'Excess',
    shortage: 'Shortage',
    noDifference: 'No Difference',
    
    // Messages
    openSuccess: 'Shift opened successfully',
    closeSuccess: 'Shift closed successfully',
    openError: 'Error opening shift',
    closeError: 'Error closing shift',
    alreadyActiveShift: 'There is already an active shift',
    noActiveShiftMessage: 'No active shift found. Please open a shift before creating invoices',
    cannotCloseOtherUserShift: 'Cannot close another user\'s shift',
    confirmClose: 'Are you sure you want to close this shift?',
    confirmCloseTitle: 'Confirm Close Shift',
    
    // Filters
    filterByBranch: 'Filter by Branch',
    filterByUser: 'Filter by User',
    filterByStatus: 'Filter by Status',
    filterByDate: 'Filter by Date',
    fromDate: 'From Date',
    toDate: 'To Date',
    allBranches: 'All Branches',
    allUsers: 'All Users',
    allStatuses: 'All Statuses',
  },
  fr: {
    title: 'Gestion des quarts de travail',
    shifts: 'Quarts de travail',
    openShift: 'Ouvrir un quart',
    closeShift: 'Fermer un quart',
    activeShift: 'Quart actif',
    noActiveShift: 'Aucun quart actif',
    shiftDetails: 'Détails du quart',
    shiftHistory: 'Historique des quarts',
    
    // Form Fields
    branchId: 'Succursale',
    openingBalance: 'Solde d\'ouverture',
    closingBalance: 'Solde de clôture',
    expectedAmount: 'Montant attendu',
    actualAmount: 'Montant réel',
    cashDifference: 'Différence en espèces',
    differenceReason: 'Raison de la différence',
    notes: 'Notes',
    status: 'Statut',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    openedBy: 'Ouvert par',
    closedBy: 'Fermé par',
    
    // Status
    statusOpen: 'Ouvert',
    statusClosed: 'Fermé',
    statusCancelled: 'Annulé',
    
    // Summary
    totalInvoices: 'Total des factures',
    totalSales: 'Total des ventes',
    totalCashSales: 'Ventes en espèces',
    totalNonCashSales: 'Ventes non en espèces',
    openingBalanceLabel: 'Solde d\'ouverture',
    expectedCashAmount: 'Montant en espèces attendu',
    excess: 'Excédent',
    shortage: 'Manque',
    noDifference: 'Aucune différence',
    
    // Messages
    openSuccess: 'Quart ouvert avec succès',
    closeSuccess: 'Quart fermé avec succès',
    openError: 'Erreur lors de l\'ouverture du quart',
    closeError: 'Erreur lors de la fermeture du quart',
    alreadyActiveShift: 'Il y a déjà un quart actif',
    noActiveShiftMessage: 'Aucun quart actif trouvé. Veuillez ouvrir un quart avant de créer des factures',
    cannotCloseOtherUserShift: 'Impossible de fermer le quart d\'un autre utilisateur',
    confirmClose: 'Êtes-vous sûr de vouloir fermer ce quart?',
    confirmCloseTitle: 'Confirmer la fermeture du quart',
    
    // Filters
    filterByBranch: 'Filtrer par succursale',
    filterByUser: 'Filtrer par utilisateur',
    filterByStatus: 'Filtrer par statut',
    filterByDate: 'Filtrer par date',
    fromDate: 'Date de début',
    toDate: 'Date de fin',
    allBranches: 'Toutes les succursales',
    allUsers: 'Tous les utilisateurs',
    allStatuses: 'Tous les statuts',
  },
}


